import { t } from '@lingui/macro';
import * as yup from 'yup';
export const schema = () => {
    const requiredNameMessage = t({
        message: 'Name is required',
        comment: 'validation message when no data is provided for name field',
    });
    return yup.object().shape({
        name: yup.string().min(1).required(requiredNameMessage),
        description: yup.string(),
    });
};
